import { Fragment, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ShippingAddress } from "../MyOrderList/view/shippingAddress";
import { isValidArray } from "../../../Layout/Common/common";

import { OrderViewSkeleton } from "../../../Skeleton/orderViewSkeleton";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { showAddItemToast } from "../../../utils/cartToastManager";
import { showErrorSnackbar } from "../../../utils/snackbarNotifications";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { OrderStatus } from "../MyOrderList/view/orderStatus";
import { OrderDetailSkeleton } from "../../../Skeleton/OrderDetailSkeleton";
import { useOrderClarificationModal } from "../../../Context/OrderClarificationPopUpContext";
import { PendingOrderDetailClarification } from "./pendingOrderClarification";
import { PendingOrderItemList } from "./pendingOrderItemList";
import { PendingOrderSummary } from "./pendingOrderSummary";
import { useAuth } from "../../../Context/AuthContext";

export const PendingViewOrderDetails = ({ orderId }) => {
  const [order_Id, setOrder_Id] = useState(null);
  const [orderDetail, setOrderDetail] = useState(null);
  const [orderItems, setOrderItems] = useState(null);
  const [clarificationChecked, setClarificationChecked] = useState(false);
  const { getOrderDetail, getOrderItems, deleteOrderHistory } = useGlobalFunction();
  const printRef = useRef();
  const clarificationRef = useRef();
  const histroy = useNavigate();
  const invoiceEligible = JSON.parse(process.env.REACT_APP_INVOICE_ELIGIBLE_STATUS || "[]");
  const { showOrderClarification } = useOrderClarificationModal();
  const { userId, role } = useAuth();

  useEffect(() => {
    async function loadOrderDetail(orderId) {
      let response = await getOrderDetail(orderId);
      if (response) {
        setOrderDetail(response);
        if (response) {
          getOrderItemsList(response.orderId);
        } else {
          showErrorSnackbar("Unable to fetch order details. Please check and try again later.");
        }
      } else {
        showErrorSnackbar("Unable to fetch order details. Please check and try again later.");
      }
    }
    setClarificationChecked(false);
    if (orderId) {
      loadOrderDetail(orderId);
      setOrder_Id(orderId);
    } else {
      setOrderDetail(null);
    }
  }, [orderId]);

  // deleteWhenEmpty is passed only by the row's remove action. The initial load calls this too,
  // and a fetch that fails comes back null - neither must be allowed to destroy the order.
  const getOrderItemsList = async (oid, { deleteWhenEmpty = false } = {}) => {
    const response = await getOrderItems(oid);
    setOrderItems(response ?? null);

    if (deleteWhenEmpty && response && !isValidArray(response.cartItem)) {
      await deleteOrderHistory({ orderId: String(oid) });
      histroy("/myaccount/pending-orders");
    }
    return response;
  };
  const handleCheckOutClick = (e) => {
    e.preventDefault();
    if (clarificationRef.current?.isClarification) {
      showOrderClarification();
    } else {
      const oid = orderDetail.orderId;
      histroy(`/Checkout/${oid}`);
    }
  };

  const handlePrint = (event) => {
    event?.preventDefault();

    if (!printRef.current) {
      return;
    }

    const styleTags = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
      .map((styleNode) => styleNode.outerHTML)
      .join("");

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.setAttribute("aria-hidden", "true");
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow?.document;
    if (!iframeDoc) {
      document.body.removeChild(iframe);
      return;
    }

    iframeDoc.open();
    iframeDoc.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Order Invoice ${order_Id || ""}</title>
          ${styleTags}
        </head>
        <body>${printRef.current.innerHTML}</body>
        </html>
      `);
    iframeDoc.close();

    setTimeout(() => {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 500);
    }, 250);
  };
  return (
    <Fragment>
      {orderDetail ? (
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address">
                  <h1 className="myaccount-title mb-2">Order Invoice #:{orderDetail.invoiceNo ?? ""}</h1>
                  <div className="order-invoice">
                    <p>
                      Customer Order Number: <span>{orderDetail.poNumber}</span>
                    </p>
                    <p>
                      Invoice Date: <span>{orderDetail.invoiceDate}</span>
                    </p>
                  </div>
                </div>
                {role != "3" ? (
                  <div className="reorder-download">
                    <div className="button-effect">
                      <button
                        type="button"
                        onClick={handleCheckOutClick}
                        disabled={!clarificationChecked}
                        className="btn btn-products btn-addcart green-btn"
                      >
                        Checkout Now
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="row mt-3 mt-md-4 billingShipping-wrapper">
            <ShippingAddress params={orderDetail} />
            <OrderStatus data={orderDetail} ispending={true} />
            <PendingOrderDetailClarification
              ref={clarificationRef}
              orderId={orderDetail.orderId}
              onResolved={() => setClarificationChecked(true)}
            />
            {orderItems && orderItems.cartItem ? (
              <PendingOrderItemList items={orderItems} orderId={orderDetail.orderId} onUpdate={getOrderItemsList} />
            ) : (
              <OrderDetailSkeleton />
            )}
            {/* </div>
            </div> */}
          </div>
          {/* <BacktoPrevious /> */}
        </div>
      ) : (
        <OrderViewSkeleton />
      )}
    </Fragment>
  );
};
